var map = {
	"./chat/0_Intro.mp4": 32,
	"./chat/1_Intro.mp4": 33,
	"./chat/2_Intro.mp4": 34,
	"./chat/3_Intro.mp4": 35,
	"./excel/0_Intro.mp4": 36,
	"./excel/1_Intro.mp4": 37,
	"./excel/2_Intro.mp4": 38,
	"./excel/3_Intro.mp4": 39,
	"./excel/4_Intro.mp4": 40,
	"./excel/5_Intro.mp4": 41,
	"./excel/6_Intro.mp4": 42,
	"./excel/7_Intro.mp4": 43,
	"./excel/8_Intro.mp4": 44,
	"./excel/9_Intro.mp4": 45,
	"./outlook/0_Intro.mp4": 46,
	"./outlook/1_Intro.mp4": 47,
	"./outlook/2_Intro.mp4": 48,
	"./outlook/3_Intro.mp4": 49,
	"./outlook/4_Intro.mp4": 50,
	"./outlook/5_Intro.mp4": 51,
	"./outlook/6_Intro.mp4": 52,
	"./outlook/7_Intro.mp4": 53,
	"./outlook/8_Intro.mp4": 54,
	"./teams/0_Intro.mp4": 55,
	"./teams/1_Intro.mp4": 56,
	"./teams/2_Intro.mp4": 57,
	"./teams/3_Intro.mp4": 58,
	"./teams/4_Intro.mp4": 59,
	"./word/0_Intro.mp4": 60,
	"./word/1_Intro.mp4": 61,
	"./word/2_Intro.mp4": 62,
	"./word/3_Intro.mp4": 63,
	"./word/4_Intro.mp4": 64,
	"./word/5_Intro.mp4": 65,
	"./word/6_Intro.mp4": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;